import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Icon from 'apps/new-web/views/components/icon';
import I18n from 'apps/new-web/views/components/i18n';
import Image from 'apps/new-web/views/components/image';
import BackgroundImage from 'apps/new-web/views/components/background-image';
import STAR_SOLID from '@ifit/react-icons/dist/icons/STAR_SOLID';
import { white } from 'apps/new-web/views/themes/colors';

class MobileReviews extends Component {
  render() {
    const settings = {
      arrows: true,
      autoplay: true,
      autoplaySpeed: 6000,
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      touchMove: true
    };
    const { noAlts, reviews } = this.props;

    return (
      <BackgroundImage
        className="reviews-mobile-component hide-on-tablet hide-on-desktop"
        src={ '/marketing/homepage/components/corporate-reviews/img/desktop-bg.jpg' }
      >
        <div className="rating-banner">
          <div className="star-section">
            <Icon icon={ STAR_SOLID } color={ white } size={ 34 } />
            <Icon icon={ STAR_SOLID } color={ white } size={ 34 } />
            <Icon icon={ STAR_SOLID } color={ white } size={ 34 } />
            <Icon icon={ STAR_SOLID } color={ white } size={ 34 } />
            <Image
              className="star"
              src={ '/marketing/homepage/components/corporate-reviews/img/three-quarter-star-white.svg' }
            />
            <div className="rating" aria-hidden="true">
              <I18n
                desc="Shows that iFit users rate our workouts 4.75 stars out of 5 stars."
                args={{ spanBegin: '<span class="small-number">', endSpan: '</span>' }}
              >
                4.75[spanBegin]/ 5[endSpan]
              </I18n>
            </div>
          </div>
          <h2><I18n desc="Shows a number that is the average rating our iFit users give our workouts.">Average workout rating from our customers</I18n></h2>
          <span className="sr-only">
            <I18n desc="Shows that iFit users rate our workouts 4.75 stars out of 5 stars.">
              4.75 out of 5 stars
            </I18n>
          </span>
        </div>
        <Slider
          className="mobile-slider"
          ref="slider"
          { ...settings }
        >
          { reviews.map((review, index) => {
            return (
              <div key={ review.alt } className={ `mobile-slide mobile-slide-${index}` }>
                <div className="mobile-slide-card">
                  <div className="mobile-slide-copy">
                    <Image
                      src={ `/marketing/homepage/components/corporate-reviews/img/logo-mobile-${ review.logo }` }
                      alt={ noAlts ? '' : review.brand }
                    />
                    <q dangerouslySetInnerHTML={{ __html: review.copy }} />
                  </div>
                </div>
              </div>
            );
          })
          }
        </Slider>
      </BackgroundImage>
    );
  }
}

MobileReviews.propTypes = {
  noAlts: PropTypes.bool,
  reviews: PropTypes.array
};

export default MobileReviews;
